/* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Contract, utils } from "ethers";
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address"
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address"
            }
        ],
        name: "AdminChanged",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address"
            }
        ],
        name: "BeaconUpgraded",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8"
            }
        ],
        name: "Initialized",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newGistRoot",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "newIdentitesStatesRoot",
                type: "bytes32"
            }
        ],
        name: "SignedStateTransited",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address"
            }
        ],
        name: "Upgraded",
        type: "event"
    },
    {
        inputs: [],
        name: "P",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "signer_",
                type: "address"
            },
            {
                internalType: "address",
                name: "sourceStateContract_",
                type: "address"
            },
            {
                internalType: "string",
                name: "sourceChainName_",
                type: "string"
            },
            {
                internalType: "string",
                name: "chainName_",
                type: "string"
            }
        ],
        name: "__LightweightStateV2_init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "signer_",
                type: "address"
            },
            {
                internalType: "string",
                name: "chainName_",
                type: "string"
            }
        ],
        name: "__Signers_init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "chainName",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "newSignerPubKey_",
                type: "bytes"
            },
            {
                internalType: "bytes",
                name: "signature_",
                type: "bytes"
            }
        ],
        name: "changeSigner",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newSourceStateContract_",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "signature_",
                type: "bytes"
            }
        ],
        name: "changeSourceStateContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "methodId_",
                type: "uint8"
            },
            {
                internalType: "address",
                name: "contractAddress_",
                type: "address"
            },
            {
                internalType: "bytes32",
                name: "signHash_",
                type: "bytes32"
            },
            {
                internalType: "bytes",
                name: "signature_",
                type: "bytes"
            }
        ],
        name: "checkSignatureAndIncrementNonce",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "getCurrentGISTRootInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "root",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "createdAtTimestamp",
                        type: "uint256"
                    }
                ],
                internalType: "struct ILightweightStateV2.GistRootData",
                name: "",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "getGISTRoot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "root_",
                type: "uint256"
            }
        ],
        name: "getGISTRootInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "root",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "createdAtTimestamp",
                        type: "uint256"
                    }
                ],
                internalType: "struct ILightweightStateV2.GistRootData",
                name: "",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root_",
                type: "bytes32"
            }
        ],
        name: "getIdentitiesStatesRootData",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "root",
                        type: "bytes32"
                    },
                    {
                        internalType: "uint256",
                        name: "setTimestamp",
                        type: "uint256"
                    }
                ],
                internalType: "struct ILightweightStateV2.IdentitiesStatesRootData",
                name: "",
                type: "tuple"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "methodId_",
                type: "uint8"
            },
            {
                internalType: "address",
                name: "contractAddress_",
                type: "address"
            }
        ],
        name: "getSigComponents",
        outputs: [
            {
                internalType: "string",
                name: "chainName_",
                type: "string"
            },
            {
                internalType: "uint256",
                name: "nonce_",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "identitiesStatesRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "root_",
                type: "bytes32"
            }
        ],
        name: "isIdentitiesStatesRootExists",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
            {
                internalType: "uint8",
                name: "",
                type: "uint8"
            }
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "newIdentitiesStatesRoot_",
                type: "bytes32"
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "root",
                        type: "uint256"
                    },
                    {
                        internalType: "uint256",
                        name: "createdAtTimestamp",
                        type: "uint256"
                    }
                ],
                internalType: "struct ILightweightStateV2.GistRootData",
                name: "gistData_",
                type: "tuple"
            },
            {
                internalType: "bytes",
                name: "proof_",
                type: "bytes"
            }
        ],
        name: "signedTransitState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "signer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "sourceChainName",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "sourceStateContract",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address"
            }
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes"
            }
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation_",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "signature_",
                type: "bytes"
            }
        ],
        name: "upgradeToWithSig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "methodId_",
                type: "uint8"
            },
            {
                internalType: "address",
                name: "contractAddress_",
                type: "address"
            },
            {
                internalType: "address",
                name: "newAddress_",
                type: "address"
            },
            {
                internalType: "bytes",
                name: "signature_",
                type: "bytes"
            }
        ],
        name: "validateChangeAddressSignature",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function"
    }
];
export class LightweightStateV2__factory {
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
_define_property(LightweightStateV2__factory, "abi", _abi);

//# sourceMappingURL=LightweightStateV2__factory.js.map